module.exports = __webpack_public_path__ + "static/media/flask.33b46075.svg";